/**
 * Header component for subscription form page.
 */

import { Typography, Stack } from "@altimateai/lego";
import { BackButton } from "@/components/button";

interface SubscriptionFormHeaderProps {
  isEditMode: boolean;
  isFromTemplate: boolean;
}

export const SubscriptionFormHeader = ({ isEditMode, isFromTemplate }: SubscriptionFormHeaderProps) => {
  const getTitle = () => {
    if (isEditMode) return "Edit Subscription";
    if (isFromTemplate) return "Create from Template";
    return "Create a new Subscription";
  };

  return (
    <Stack direction="row" align="center" gap="md">
      <BackButton defaultUrl={"/subscriptions"} />
      <Typography variant="page-heading" className="al-text-gray-900">
        {getTitle()}
      </Typography>
    </Stack>
  );
};
